<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{$t('detailUtilisateur.listeService')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="card card-honrizontal"
               :class="{'mgt-20px': $index !== 0}"
               v-for="(service, $index) in utilisateur.services" :key="service.id">
            <div class="columns is-vcentered is-marginless" >
              <div class="column is-3">
                <div>
                  <span class="has-text-weight-bold is-size-4 has-text-link">
                    {{service.nomCommercial }}
                  </span>
                </div>
                <router-link-blank
                  :to="{ name: 'c.parametrage.service', params: {id: service.id}}"
                  :message="service.code"/>
              </div>
              <div class="column is-5">
                <span class="has-text-default">
                  {{getAddress(service.adresse)}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  props: {
    utilisateur: {
      type: Object,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
  },
  methods: {
    getAddress(adresse) {
      return adressFullStringGetter(adresse);
    },
  },
};
</script>
